import React from 'react';

function bannerClasses(type) {
  switch (type) {
    case 'error':
      return 'border-red-200 bg-red-50 text-red-800';
    case 'success':
      return 'border-emerald-200 bg-emerald-50 text-emerald-800';
    default:
      return 'border-amber-200 bg-amber-50 text-amber-800';
  }
}

function AppShellBanner({ banner, onClose }) {
  if (!banner?.message) return null;

  return (
    <div className={`no-print border-b px-4 py-2 text-sm ${bannerClasses(banner.type)}`}>
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
        <p className="font-medium">{banner.message}</p>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg px-2 py-1 text-xs font-bold hover:bg-white/60"
        >
          بستن
        </button>
      </div>
    </div>
  );
}

export default AppShellBanner;
